import { useEffect } from 'react';
import { useVersionCheck } from './useVersionCheck';

/**
 * Hook que ejecuta la verificación de actualizaciones en segundo plano
 * Completamente invisible para el usuario
 */
export const useSilentUpdate = (): void => {
  const { checkForUpdates } = useVersionCheck();

  useEffect(() => {
    // Ejecutar verificación inicial
    checkForUpdates();

    // Configurar verificación periódica
    const interval = setInterval(checkForUpdates, 10 * 60 * 1000); // 10 minutos

    // Limpiar intervalo al desmontar
    return () => clearInterval(interval);
  }, [checkForUpdates]);

  // Verificar cuando el usuario vuelve a la app (cambio de pestaña)
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        checkForUpdates();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, [checkForUpdates]);
};
